import { render, staticRenderFns } from "./Survery.vue?vue&type=template&id=9c8670ae&"
import script from "./Survery.vue?vue&type=script&lang=ts&"
export * from "./Survery.vue?vue&type=script&lang=ts&"
import style0 from "./Survery.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports